import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faCheck, faTimes, faQuestion, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { Attendee, Request } from '../../types';
import { attendeeSet } from '../../store/attendeeSlice';
import getFileURL from '../../utils/getFileURL';

export interface RequestItemProps {
	request: Request;
    filter: string;
};

const RequestItem: FC<RequestItemProps> = ({ request, filter }) => {
	const { i18n } = useTranslation();
	const name = i18n.language === 'en' ? 'name_en' : 'name_ru';
    const date = i18n.language === 'en' ? 'date_en' : 'date_ru';
    const duration = i18n.language === 'en' ? 'min' : 'мин';
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const slots = useAppSelector(store => store.slots);
    const attendees = useAppSelector(store => store.attendees);
    const [ time, setTime ] = useState('');
    const [ respondent, setRespondent ] = useState<Attendee|null>(null);
    const [ icon, setIcon ] = useState<IconDefinition>(faQuestion);

    useEffect(() => {
        const slot = slots.find(s => s.id === request.slot_id);
        const respondent = attendees.find(a => a.id === request.from_id || a.id === request.to_id);
        if(!slot || !respondent) return;
        const [ hour, min ] = slot.start.split('T')[1].split(':');
        setTime(`${slot[date]} ${hour}:${min} - ${slot.duration} ${duration}`);
        setRespondent(respondent);

        switch(request.status) {
            case 'approved':
                setIcon(faCheck);
                break;
            case 'cancelled':
                setIcon(faTimes);
                break;
            case 'rejected':
                setIcon(faTimes);
                break;
            case 'negotiation':
                if(request.from_id === respondent.id) setIcon(faArrowDown); else setIcon(faArrowUp);
                break;
            default:
                setIcon(faQuestion);
                break;
        }
    }, [ request, slots, attendees, date, duration ])

    const onClick = () => {
        if(respondent) {
            dispatch(attendeeSet(respondent));
            navigate('attendee');
        }
    };

    if(filter && request.status !== filter) return null;
    if(request.from_id === request.to_id || !respondent) return null;

	return (
        <li onClick={() => onClick()}>
            <img alt='avatar' className='Avatar' src={getFileURL(respondent.avatar)}/>
            <div className='Text'>
                {respondent[name]}<br/>
                <small>{time}</small>
            </div>
            <Icon icon={icon} fixedWidth className='Icon'/>
        </li>
	);
};

export default RequestItem;
